'use strict';

angular.module('app')
    .service('PrinterService', [function () {
        var getDateStr = function (dateTime) {
            if (!dateTime) {
                return '';
            }

            return dateTime.toLocaleDateString('en-US', {weekday: 'short'}) + ' ' + dateTime.toLocaleDateString('en-US', {
                year: '2-digit',
                month: '2-digit',
                day: '2-digit'
            }) + ' ' + dateTime.toLocaleString('en-US', {hour: 'numeric', hour12: true, minute: 'numeric'});
        };
        this.getDateStr = getDateStr;

        var getPrintRequestAddress = function (printerIpAddress) {
            var transformedIp = printerIpAddress.replace(/\./g, '_');
            return 'https://' + transformedIp + '.marginedgedevices.com';
        };
        
        this.getPrintRequestAddress = getPrintRequestAddress;
        
    }]);